export default [{
  title: 'header.document',
  router: '/document/0',
  isApp: true,
  menuCode: '001',
  icon: 'h-icon-menu'
},
{
  title: 'header.document',
  router: '/download',
  isApp: true,
  menuCode: '002',
  icon: 'h-icon-menu'
}]
